// extracted by mini-css-extract-plugin
module.exports = {"column":"footerlink_column__mBAGY","linkItem":"footerlink_linkItem__GPnet"};